/* Mohan Ghee — PDP interactions
   - Gallery: mobile swiper + desktop thumb-click main image swap
   - Variant chips → price/url update + Shopify variant input
   - Quantity stepper (in-form + sticky bottom) kept in sync
   - Tabs, accordion, bundle math, share, wishlist (basic) */
(function () {
  'use strict';

  const $ = (s, root) => (root || document).querySelector(s);
  const $$ = (s, root) => Array.from((root || document).querySelectorAll(s));
  const fmt = (n) => '₹' + Number(Math.round(n / 100)).toLocaleString('en-IN');

  // ============ Gallery ============
  (function gallery() {
    const root = $('[data-pdp-gallery]');
    if (!root) return;
    const track = $('[data-pdp-gallery-track]', root);
    const slides = $$('.pdp-gallery__slide', root);
    const dots = $$('.pdp-gallery__dot', root);
    const thumbs = $$('.pdp-gallery__thumb', root);
    const main = $('[data-pdp-main]', root);
    let idx = 0;
    const total = slides.length;
    if (!total) return;

    const isDesktop = () => window.matchMedia('(min-width: 768px)').matches;

    function go(i) {
      idx = ((i % total) + total) % total;
      if (isDesktop()) {
        // Desktop: swap main image src
        const targetSrc = thumbs[idx]?.dataset.img || slides[idx]?.querySelector('img')?.src;
        if (main && targetSrc) main.src = targetSrc;
      } else {
        // Mobile: translate track
        if (track) track.style.transform = `translateX(-${idx * 100}%)`;
      }
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === idx));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === idx));
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));

    // Touch swipe (mobile)
    let startX = 0, dx = 0, touching = false;
    const viewport = $('.pdp-gallery__viewport', root);
    if (viewport) {
      viewport.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; dx = 0; touching = true; }, { passive: true });
      viewport.addEventListener('touchmove', (e) => { if (touching) dx = e.touches[0].clientX - startX; }, { passive: true });
      viewport.addEventListener('touchend', () => {
        if (!touching) return;
        touching = false;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      });
    }

    // Re-set on resize so mobile/desktop transitions cleanly
    window.addEventListener('resize', () => go(idx));

    // Variant chips live outside this closure; they announce their variant's
    // featured image (slide index) and the gallery navigates to it.
    document.addEventListener('pdp:show-image', (e) => {
      const i = e.detail;
      if (Number.isInteger(i) && i >= 0 && i < total) go(i);
    });
  })();

  // ============ Variant selector ============
  const variantInput = $('[data-pdp-variant-input]');
  const variantLabel = $('[data-pdp-variant-label]');
  const priceNow = $('[data-pdp-price-now]');
  const priceWas = $('[data-pdp-price-was]');
  const priceSave = $('[data-pdp-price-save]');
  const atcBtn = $('[data-pdp-atc]');
  const atcTotal = $('[data-pdp-atc-total]');
  const stickyTotal = $('[data-pdp-sticky-total]');
  const qtyInput = $('[data-pdp-qty]');
  const stickyQty = $('[data-pdp-sticky-qty]');

  function getQty() {
    const v = parseInt(qtyInput?.value || stickyQty?.value || '1', 10);
    return isNaN(v) || v < 1 ? 1 : v;
  }

  function syncQty(value) {
    const v = Math.max(1, Math.min(10, parseInt(value, 10) || 1));
    if (qtyInput) qtyInput.value = v;
    if (stickyQty) stickyQty.value = v;
    refreshTotals();
  }

  function refreshTotals() {
    const active = $('.pdp-chip.is-active');
    if (!active) return;
    const price = +active.dataset.price;
    const was = +active.dataset.was;
    const qty = getQty();
    const total = price * qty;
    const wasTotal = was * qty;
    const savePct = was > price ? Math.round(((was - price) / was) * 100) : 0;

    if (priceNow) priceNow.textContent = fmt(total);
    if (priceWas) {
      if (was > price) {
        priceWas.textContent = fmt(wasTotal);
        priceWas.hidden = false;
      } else priceWas.hidden = true;
    }
    if (priceSave) {
      if (savePct > 0) {
        priceSave.textContent = 'Save ' + savePct + '%';
        priceSave.hidden = false;
      } else priceSave.hidden = true;
    }
    if (atcTotal) atcTotal.textContent = fmt(total);
    if (stickyTotal) stickyTotal.textContent = fmt(total);
  }

  $$('.pdp-chip').forEach((chip) => {
    chip.addEventListener('click', () => {
      if (chip.classList.contains('pdp-chip--out') || chip.disabled) return;
      $$('.pdp-chip').forEach((c) => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      if (variantInput) variantInput.value = chip.dataset.variantId;
      if (variantLabel) variantLabel.textContent = chip.dataset.label;
      // Update URL with variant
      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', chip.dataset.variantId);
        history.replaceState(null, '', url.toString());
      }
      refreshTotals();
      // Show this variant's own image (chips without one leave the gallery be)
      if (chip.dataset.imageIdx !== undefined) {
        document.dispatchEvent(new CustomEvent('pdp:show-image', { detail: +chip.dataset.imageIdx }));
      }
    });
  });

  // Deep links (?variant=...) land on that variant's image too. Plain loads
  // keep the client's chosen first image — only an explicit link jumps.
  if (new URLSearchParams(location.search).has('variant')) {
    const activeChip = $('.pdp-chip.is-active');
    if (activeChip && activeChip.dataset.imageIdx !== undefined) {
      document.dispatchEvent(new CustomEvent('pdp:show-image', { detail: +activeChip.dataset.imageIdx }));
    }
  }

  // ============ Quantity steppers ============
  $('[data-pdp-qty-dec]')?.addEventListener('click', () => syncQty(getQty() - 1));
  $('[data-pdp-qty-inc]')?.addEventListener('click', () => syncQty(getQty() + 1));
  $('[data-pdp-sticky-dec]')?.addEventListener('click', () => syncQty(getQty() - 1));
  $('[data-pdp-sticky-inc]')?.addEventListener('click', () => syncQty(getQty() + 1));
  qtyInput?.addEventListener('input', () => syncQty(qtyInput.value));
  stickyQty?.addEventListener('input', () => syncQty(stickyQty.value));

  // ============ Sticky ATC -> submit main form ============
  const mainForm = $('[data-pdp-form]');
  $('[data-pdp-sticky-atc]')?.addEventListener('click', () => mainForm?.requestSubmit?.());
  $('[data-pdp-sticky-buy]')?.addEventListener('click', () => buyNow());
  $('[data-pdp-buy-now]')?.addEventListener('click', (e) => { e.preventDefault(); buyNow(); });

  function buyNow() {
    if (!mainForm) return;
    const formData = new FormData(mainForm);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then((r) => r.json())
      .then(() => { window.location.href = '/checkout'; })
      .catch(() => { window.location.href = '/cart'; });
  }

  // ============ Tabs ============
  $$('.pdp-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const k = tab.dataset.pdpTab;
      $$('.pdp-tab').forEach((t) => t.classList.toggle('is-active', t === tab));
      $$('.pdp-tabpanel').forEach((p) => p.classList.toggle('is-active', p.dataset.pdpPanel === k));
    });
  });

  // ============ Accordion ============
  $$('[data-pdp-acc-toggle]').forEach((h) => {
    h.addEventListener('click', () => h.closest('.pdp-acc__item')?.classList.toggle('is-open'));
  });

  // ============ Bundle ============
  (function bundle() {
    const root = $('[data-pdp-bundle]');
    if (!root) return;
    const items = $$('.pdp-bundleitem', root);
    const nowEl = $('[data-pdp-bundle-now]', root);
    const wasEl = $('[data-pdp-bundle-was]', root);
    const saveEl = $('[data-pdp-bundle-save]', root);

    function recalc() {
      let now = 0, was = 0, n = 0;
      items.forEach((item) => {
        const check = $('[data-pdp-bundle-toggle]', item);
        if (check && check.classList.contains('is-checked')) {
          now += +item.dataset.price;
          was += +item.dataset.was;
          n++;
        }
      });
      // 8% extra discount when all items checked
      if (n === items.length && items.length >= 2) now = Math.round(now * 0.92);
      if (nowEl) nowEl.textContent = fmt(now);
      if (wasEl) {
        if (was > now) { wasEl.textContent = fmt(was); wasEl.hidden = false; }
        else wasEl.hidden = true;
      }
      if (saveEl) {
        if (was > now) { saveEl.textContent = 'Save ' + fmt(was - now); saveEl.hidden = false; }
        else saveEl.hidden = true;
      }
    }

    $$('[data-pdp-bundle-toggle]', root).forEach((c) => {
      c.addEventListener('click', () => {
        c.classList.toggle('is-checked');
        recalc();
      });
    });
    recalc();

    // "Add N items to cart" button
    $('[data-pdp-bundle-add]', root)?.addEventListener('click', async () => {
      const variantIds = items
        .filter((i) => $('[data-pdp-bundle-toggle]', i)?.classList.contains('is-checked'))
        .map((i) => i.dataset.variantId)
        .filter(Boolean);
      if (!variantIds.length) return;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: variantIds.map((id) => ({ id: +id, quantity: 1 })) }),
        });
        window.location.href = '/cart';
      } catch (e) {
        window.location.href = '/cart';
      }
    });
  })();

  // ============ Share / Wishlist (basic stubs) ============
  $('[data-pdp-share]')?.addEventListener('click', async () => {
    const data = { title: document.title, url: window.location.href };
    if (navigator.share) { try { await navigator.share(data); } catch (e) {} }
    else if (navigator.clipboard) {
      await navigator.clipboard.writeText(data.url);
    }
  });
  $('[data-pdp-wishlist]')?.addEventListener('click', (e) => {
    e.currentTarget.classList.toggle('is-liked');
  });

  // Init: ensure totals reflect current default chip + qty
  refreshTotals();
})();
